export const regionResellers = [349, 178];
